export default __webpack_public_path__ + "static/media/send-solid-grey.dc8f9348.svg";